import moment from 'moment';
import React from 'react';
import { connect } from "react-redux";
import { useStyles } from "./styles";
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined';
import ContactAvatar from '../ContactAvatar';
import { conversationDisplayName, formatUsPhone } from '../../utils/contacts';
import { setSmsContact, resetSmsContact } from "../../store/features/smsConversations/smsContactSlice";
import { clearSms, initNewSms } from "../../store/features/smsConversations/smsNewMessageSlice";
import { clearMms, initNewMms } from "../../store/features/smsConversations/smsNewMmsSlice";
import { setSmsNewConversationActive, setSmsNewConversationNumber } from "../../store/features/smsConversations/smsNewConversationSlice";

const mapDispatchToProps = {
  setSmsContact,
  resetSmsContact,
  setSmsNewConversationActive,
  setSmsNewConversationNumber,
  clearSms,
  initNewSms,
  clearMms,
  initNewMms,
};

// "14:05" today, "Yesterday", weekday within the week, otherwise a short date.
export const listTimestamp = (dateTime) => {
  const time = moment(dateTime);
  const now = moment();
  if (now.isSame(time, 'day')) return time.format('LT');
  if (now.clone().subtract(1, 'day').isSame(time, 'day')) return 'Yesterday';
  if (moment.duration(now.diff(time)).as('days') < 7) return time.format('ddd');
  if (now.isSame(time, 'year')) return time.format('MMM D');
  return time.format('MM/DD/YY');
};

const SmsContactsListItem = (props) => {
  const {
    smsContact,
    resetSmsContact,
    setSmsNewConversationActive,
    setSmsNewConversationNumber,
    clearSms,
    initNewSms,
    clearMms,
    initNewMms,
    setSmsContact,
    setValue,
    phonebook,
    externalPhonebook,
    personalPhonebook,
  } = props;

  const { classes, cx } = useStyles();

  const discardNewMessage = () => {
    resetSmsContact();
    setSmsNewConversationActive(false);
    setSmsNewConversationNumber("");
    clearSms("new");
    clearMms("new");
  }

  const { profileImage, number, number_pretty, lastMessage, unreadMessages, conversation_id } = props.data;
  const isDraft = conversation_id === 'new';
  const selected = smsContact.id === conversation_id;
  const unread = !isDraft && unreadMessages && unreadMessages !== 0;

  const resolvedName = isDraft ? "" : conversationDisplayName(props.data, [personalPhonebook, phonebook, externalPhonebook]);

  const getName = () => {
    if (isDraft) return "New message";
    // A name that is only a number is shown like every other number in the app.
    return formatUsPhone((resolvedName !== "") ? resolvedName
                                                : number_pretty || number);
  }

  const unreadMessagesLabel = unread ? ((unreadMessages > 999) ? '999+' : unreadMessages) : null;

  return (
    <div className={cx(classes.smsContactsListItem, selected && classes.smsContactsListItemSelected)}>
      <Button
        id={conversation_id}
        disableRipple
        className={classes.button}
        onClick={(e) => {
          initNewSms(conversation_id);
          initNewMms(conversation_id);
          setSmsContact(props.data);
          if (setValue) {
            setValue(number);
          }
        }}>
        <ContactAvatar
          className={classes.avatar}
          name={resolvedName}
          number={number}
          image={profileImage}
          size={44}
        />
        <div className={classes.smsContactsInfo}>
          <div className={classes.contactNameDate}>
            <h1 className={cx(classes.smsContactsTitle, unread && classes.unreadTitle)}>{getName()}</h1>
            {!isDraft && lastMessage && lastMessage.dateTime && (
              <p className={cx(classes.smsContactsDate, unread && classes.unreadDate)}>{listTimestamp(lastMessage.dateTime)}</p>
            )}
          </div>
          <div className={classes.previewRow}>
            {isDraft
              ? <span className={classes.draftLabel}>{number ? formatUsPhone(number_pretty || number) : "Enter a number to start"}</span>
              : <p className={cx(classes.preview, unread && classes.unreadPreview)}>{lastMessage && lastMessage.direction === "sent" && <span className={classes.previewYou}>You: </span>}
                  {lastMessage ? (lastMessage.message || (lastMessage.type === "mms" ? "Photo" : "")) : ""}
                </p>}
            <div className={classes.badges}>
              {!isDraft && lastMessage && lastMessage.status === "failed" && (
                <ErrorOutlineIcon className={classes.notDeliveredIcon} titleAccess="Last message not delivered" />
              )}
              {unreadMessagesLabel && <span className={classes.unreadMessages}>{unreadMessagesLabel}</span>}
            </div>
          </div>
        </div>
      </Button>
      {isDraft && (
        <Tooltip title="Discard">
          <IconButton
            id='discard_button'
            size="small"
            className={classes.discardNewMessage}
            aria-label="discard new message"
            onClick={() => discardNewMessage()}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
      smsContact: state.smsContact,
      phonebook: state.phonebook,
      externalPhonebook: state.externalPhonebook,
      personalPhonebook: state.personalPhonebook,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsContactsListItem);
